module.exports = __webpack_public_path__ + "static/media/circle_explode.416a60a1.png";